import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

function Header() {
  const [isProjectsOpen, setIsProjectsOpen] = useState(false);
  const menuRef = useRef(null);
  const { language, toggleLanguage } = useLanguage();

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsProjectsOpen(false);
      }
    }
    function handleEsc(event) {
      if (event.key === 'Escape') setIsProjectsOpen(false);
    }
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEsc);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEsc);
    };
  }, []);

  return (
    <header className="bg-white border-b">
      <div className="mx-auto max-w-6xl px-4 py-2 flex items-center justify-between">
        <Link to="/">
          <img src={`${process.env.PUBLIC_URL}/logo192.png`} alt="MP Funds Logo" className="h-16 w-16" />
        </Link>
        <nav className="flex items-center gap-6">
          <Link to="/" className="hover:text-green-600">Home</Link>
          <div
            className="relative"
            ref={menuRef}
            onMouseEnter={() => setIsProjectsOpen(true)}
          >
            <button
              className="hover:text-green-600"
              aria-haspopup="menu"
              aria-expanded={isProjectsOpen}
              onClick={() => setIsProjectsOpen((v) => !v)}
            >
              Projects
            </button>
            {isProjectsOpen && (
              <div className="absolute left-0 mt-2 bg-white border rounded shadow-md min-w-[220px] z-50"
                   onMouseEnter={() => setIsProjectsOpen(true)}>
                <Link className="block px-4 py-2 hover:bg-green-50" to="/projects/ongoing" onClick={() => setIsProjectsOpen(false)}>Ongoing Projects</Link>
                <Link className="block px-4 py-2 hover:bg-green-50" to="/projects/completed" onClick={() => setIsProjectsOpen(false)}>Completed Projects</Link>
                <Link className="block px-4 py-2 hover:bg-green-50" to="/projects/proposed" onClick={() => setIsProjectsOpen(false)}>Proposed Projects</Link>
              </div>
            )}
          </div>
          <Link to="/contact" className="hover:text-green-600">Contact Us</Link>
          <Link to="/admin/login" className="ml-2 rounded-full bg-green-600 text-white px-3 py-1 text-sm hover:bg-green-700">Admin Login</Link>
          {/* <Link to="/admin" className="rounded-full border border-green-600 text-green-700 px-3 py-1 text-sm hover:bg-green-50">Dashboard</Link> */}
          {/* <button
            className="ml-2 rounded-full border border-green-600 text-green-700 px-3 py-1 text-sm hover:bg-green-50"
            onClick={toggleLanguage}
          >
            {language === 'en' ? 'Switch to Hindi' : 'Switch to English'}
          </button> */}
        </nav>
      </div>
    </header>
  );
}

export default Header;


